/**
 * Saved-listings API client — T0 Epic E.2 (buyer save & track stub).
 * All authenticated (HMAC + JWT).
 */
import { apiDelete, apiGet, apiPost } from '../../../adapters/api-client/api';

export interface SavedListing {
  vehicleId: string;
  title: string;
  listingPrice?: number;
  available: boolean;
}

export function saveListing(vehicleId: string): Promise<{ savedVehicleIds: string[] }> {
  return apiPost('/api/v1/saved-listings', { vehicleId });
}

export function unsaveListing(vehicleId: string): Promise<{ savedVehicleIds: string[] }> {
  return apiDelete(`/api/v1/saved-listings/${vehicleId}`);
}

export async function fetchSavedListings(): Promise<SavedListing[]> {
  const res = await apiGet<{ listings: SavedListing[] }>('/api/v1/saved-listings');
  return res.listings ?? [];
}
